import React from 'react';
import { Link } from 'react-router-dom';
import { FINANCE_SERVICES } from '../data/siteData';
import { useScrollReveal } from '../hooks/useScrollReveal';
import './Finance.css';
import Icon from '../components/Icon';
import financeHeroImage from '../assets/fin.jpeg';
import financeGridImage from '../assets/wealth.jpeg';

function FinanceCard({ s, index }) {
  const { ref, visible } = useScrollReveal();
  // Encode the service name for URL
  const serviceName = encodeURIComponent(s.name);
  
  return (
    <div ref={ref} id={s.id} className={`fin-card${visible ? ' visible' : ''}`} style={{ transitionDelay: `${(index % 3) * 0.1}s` }}>
      <div className="finc-icon"><Icon icon={s.icon} size={40} /></div>
      <div className="finc-name">{s.name}</div>
      <p className="finc-desc">{s.desc}</p>
      <div className="finc-features">
        {s.features.map((f, i) => (
          <div key={i} className="finc-feature"><span>✦</span>{f}</div>
        ))}
      </div>
      {/* FIXED: Pass service name to contact page */}
      <Link to={`/contact?service=${serviceName}`} className="finc-cta btn-green-outline">
        Enquire Now →
      </Link>
    </div>
  );
}

export default function Finance() {
  return (
    <div className="finance-page page-wrapper">
      {/* Hero */}
      <div className="fin-hero">
        <div className="fin-hero-grid" />
        <div className="fin-hero-glow" />
        <div className="fin-hero-inner">
          <div className="fin-hero-left">
            <div className="section-label">Finance Management</div>
            <h1 className="section-title">
              Fund Your<br /><span className="green">Aspirations</span>
            </h1>
            <p className="section-sub" style={{ marginTop: 20 }}>
              Housing Loans, Mortgage Loans, SME & Business Loans, Car Loans & Personal Loans — comprehensive finance solutions from one trusted advisor.
            </p>
            <div style={{ display: 'flex', gap: 14, marginTop: 36, flexWrap: 'wrap' }}>
              {/* FIXED: Pass finance management service name */}
              <Link to="/contact?service=Finance%20Management" className="btn-primary">Get Finance Advice →</Link>
              <a href="tel:9849131273" className="btn-ghost">📞 9849131273</a>
            </div>
          </div>
          <div className="fin-hero-right">
            <img 
              src={financeHeroImage} 
              alt="Finance and Loan Solutions" 
              className="finance-hero-image"
              style={{
                width: '100%',
                maxWidth: '500px',
                height: 'auto',
                borderRadius: '12px',
                boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
                objectFit: 'cover'
              }}
            />
          </div>
        </div>
      </div>

      {/* Loans Section */}
      <section className="fin-section">
        <div className="fins-header">
          <div className="section-label">Finance Management</div>
          <h2 className="section-title">Loan <span className="green">Solutions</span></h2>
          <p className="section-sub" style={{ marginTop: 12 }}>Access the right credit at the right time — housing, mortgage, business, or personal — with end-to-end expert guidance.</p>
        </div>
        <div className="fin-grid">
          {FINANCE_SERVICES.map((s, i) => {
            if (i === 3) {
              return (
                <React.Fragment key="image-wrapper">
                  <FinanceCard key={s.id} s={s} index={i} />
                </React.Fragment>
              );
            }
            return <FinanceCard key={s.id} s={s} index={i} />;
          })}
        </div>
      </section>

      {/* Why Finance with LMS */}
      <section className="fin-why">
        <div className="fin-why-inner">
          <div className="section-label" style={{ justifyContent: 'center' }}>Why LMS for Finance</div>
          <h2 className="section-title" style={{ textAlign: 'center', marginBottom: 60 }}>
            One Advisor for <span className="green">All Your Needs</span>
          </h2>
          <div className="fin-why-grid">
            {[
              { icon: '🔍', title: 'Unbiased Comparison', text: 'We compare products across insurers and lenders to find the best fit for you — not the highest commission product.' },
              { icon: '📋', title: 'End-to-End Support', text: 'From application to approval to claim settlement — we are with you at every step of your financial product journey.' },
              { icon: '💰', title: 'Best Rates Guaranteed', text: 'Our network of banking and NBFC partners ensures you get competitive interest rates and premium pricing.' },
              { icon: '⚡', title: 'Fast Processing', text: 'Minimal documentation and digital-first onboarding ensure quick approvals and speedy disbursements.' },
            ].map((w, i) => {
              const { ref, visible } = useScrollReveal();
              return (
                <div key={i} ref={ref} className={`finw-card${visible ? ' visible' : ''}`} style={{ transitionDelay: `${i * 0.1}s` }}>
                  <div className="finw-icon"><Icon icon={w.icon} size={40} /></div>
                  <div className="finw-title">{w.title}</div>
                  <div className="finw-text">{w.text}</div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="fin-cta">
        <div className="finc-inner">
          <h2 className="section-title"><span className="green" id='green2'>Get the Right Financial Protection</span></h2>
          <p className="section-sub" style={{ marginTop: 16, marginBottom: 40, maxWidth: 560, margin: '16px auto 40px', color:'white'}}>
            Talk to G.M. Narendra today for personalized insurance and loan advisory — completely free consultation.
          </p>
          <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
            {/* FIXED: Pass finance management service name */}
            <Link to="/contact?service=Finance%20Management" className="btn-primary">Book Free Consultation →</Link>
            <a href="tel:9849131273" className="btn-primary">📞 9849131273</a>
          </div>
        </div>
      </section>
    </div>
  );
}